"use client"

import Link from "next/link"
import { ArrowRight, Sparkles } from "lucide-react"
import { Button } from "@/components/ui/button"
import { Badge } from "@/components/ui/badge"

export default function Home() {
  return (
    <section className="relative overflow-hidden min-h-screen flex items-center justify-center">
      {/* Background gradient */}
      <div className="absolute inset-0 -z-10 bg-[radial-gradient(ellipse_80%_80%_at_50%_-20%,rgba(120,119,198,0.3),rgba(255,255,255,0))] dark:bg-[radial-gradient(ellipse_80%_80%_at_50%_-20%,rgba(120,119,198,0.15),rgba(255,255,255,0))]" />

      <div className="container mx-auto px-4 w-full">
        <div className="mx-auto max-w-4xl text-center">
          {/* Announcement badge */}
          <Badge
            variant="secondary"
            className="mb-8 animate-pulse gap-2 px-4 py-2 text-sm"
          >
            <Sparkles className="h-3.5 w-3.5" />
            <span>New: Advanced task views with Kanban, Gantt & Calendar</span>
            <ArrowRight className="h-3.5 w-3.5" />
          </Badge>

          {/* Headline */}
          <h1 className="mb-6 text-4xl font-bold tracking-tight sm:text-5xl md:text-6xl lg:text-7xl">
            Manage projects with{" "}
            <span className="bg-gradient-to-r from-primary via-purple-500 to-pink-500 bg-clip-text text-transparent">
              powerful tool
            </span>
          </h1>

          {/* Subtitle */}
          <p className="mx-auto mb-10 max-w-2xl text-lg text-muted-foreground sm:text-xl">
            The prototype of a Simple Project Management Tool
          </p>

          {/* CTA buttons */}
          <div className="flex flex-col items-center justify-center gap-4 sm:flex-row">
            <Link href="/auth/signup">
              <Button size="lg" className="w-full gap-2 sm:w-auto">
                Get Started
                <ArrowRight className="h-4 w-4" />
              </Button>
            </Link>
            <Link href="/auth/signin">
              <Button size="lg" variant="outline" className="w-full sm:w-auto">
                Sign In
              </Button>
            </Link>
          </div>

          {/* Social proof */}
          <p className="mt-12 text-sm text-muted-foreground">
            Made with Next.js, Shadcn, and Tailwind CSS<br />
            Feel free to try it out!
          </p>
        </div>
      </div>
    </section>
  )
}
